import { render, staticRenderFns } from "./SearchLastLogBabiClass.vue?vue&type=template&id=6252e88b&"
import script from "./SearchLastLogBabiClass.vue?vue&type=script&lang=js&"
export * from "./SearchLastLogBabiClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports